export const mapResponseToApiModel = ({ visitedPages, visitedQuestions }) => ({
  visited_pages: visitedPages,
  visited_questions: visitedQuestions,
});
